<div class="modal-header">
    @if (xmlType === XmlTypes.BGM15) {
        <h4 class="modal-title">{{ 'BGM15 Manifest detected' | translate }}</h4>
    }
    @if (xmlType === XmlTypes.BG415W) {
        <h4 class="modal-title">{{ 'BG415W Declaration detected' | translate }}</h4>
    }
    <button class="close" type="button" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    @if (vesselMismatch) {
        <div class="alert alert-warning">
            <strong>{{ 'Vessel mismatch' | translate }}:</strong>
            {{
                'The vessel info in the file does not match the current vessel. You may proceed, but please verify.'
                    | translate
            }}
        </div>
    }

    @if (xmlType === XmlTypes.BG415W) {
        <div>
            <p>
                {{
                    'Existing records matching the file will be updated. No new records will be created or deleted.'
                        | translate
                }}
            </p>
        </div>
    }

    @if (xmlType === XmlTypes.BGM15 && isTargetEmpty) {
        <div>
            <p>{{ 'The list will be populated with new cargo items from the imported file.' | translate }}</p>
        </div>
    }

    @if (xmlType === XmlTypes.BGM15 && !isTargetEmpty) {
        <div>
            <p>{{ 'Choose how to apply the manifest to the existing Cargo List:' | translate }}</p>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    id="replace"
                    name="mode"
                    checked
                    [value]="XmlImportModes.Replace"
                    [(ngModel)]="selectedMode" />
                <label class="form-check-label" for="replace">
                    <strong>{{ 'Replace (default)' | translate }}</strong>
                    <div class="small">
                        {{
                            'WARNING: This will remove all current records and replace them with data from the imported file.'
                                | translate
                        }}
                    </div>
                </label>
            </div>
            <div class="form-check mt-2">
                <input
                    class="form-check-input"
                    type="radio"
                    id="update"
                    name="mode"
                    [value]="XmlImportModes.Update"
                    [(ngModel)]="selectedMode" />
                <label class="form-check-label" for="update">
                    <strong>{{ 'Update / Append' | translate }}</strong>
                    <div class="small">
                        {{
                            'New cargo items will be added and existing records updated from the imported file.'
                                | translate
                        }}
                    </div>
                </label>
            </div>
        </div>
    }
</div>
<div class="modal-footer">
    <button class="btn btn-sm btn-primary mr-2" (click)="confirm()">{{ 'Confirm' | translate }}</button>
    <button class="btn btn-sm btn-secondary" (click)="cancel()">{{ 'Cancel' | translate }}</button>
</div>
